<template>
  <div class="form-wrapper">
    <form id="formapp" @submit="checkForm">
      <div class="phone-form">
        <input id="your-contact" v-model="contact" :class="{ 'error-border': contactError, 'value-ok': sent }" type="text" name="your-contact" min="0" placeholder="Telefon eller e-post" :disabled="sent || sending" />
        <span>Telefon eller e-post</span>
      </div>
      <div class="error-info" v-if="contactError">Du må skrive inn telefonnummer eller e-postadresse.</div>
      <div class="checkbox-wrap">
        <div class="checkbox-input">
          <input name="your-accept" type="checkbox" id="accept" v-model="accept" :disabled="sent || sending" />
          <label for="accept" :class="acceptError ? 'error-border' : ''"></label>
        </div>
        <label for="check1">Jeg godtar at Semway kontakter meg.</label>
      </div>
      <div class="error-info" v-if="acceptError">Før du kan sende inn meldingen må du godta personvern.</div>

      <div class="form-send" v-if="sent">
        <button class="btn btn--border-white" :disabled="sent">Melding sendt! <i class="send"></i></button>
      </div>
      <div class="chat-btn" v-else>
        <button class="btn btn--red btn--border-0" :disabled="sending"><span v-if="sending">Sendes...</span><span v-else> Send melding</span></button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      sent: null,
      sending: null,
      errors: [],
      contactError: null,
      contact: null,
      acceptError: null,
      accept: null
    }
  },
  methods: {
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validPhone: function (phone) {
      var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/
      return re.test(phone)
    },
    checkForm: function (e) {
      e.preventDefault()
      this.errors = []
      this.contactError = this.acceptError = null

      if (!this.contact) {
        this.errors.push('contact')
        this.contactError = 'Du må skrive inn telefonnummer eller e-postadresse.'
      } else if (!this.validEmail(this.contact) && !this.validPhone(this.contact)) {
        this.errors.push('contact')
        this.contactError = 'Du må skrive inn telefonnummer eller e-postadresse.'
      }
      if (!this.accept) {
        this.errors.push('accept')
        this.acceptError = 'Før du kan sende inn meldingen må du godta personvern.'
      }
      let _self = this
      if (!this.errors.length) {
        var bodyFormData = new FormData()
        bodyFormData.set('your-contact', this.contact)
        bodyFormData.set('your-accept', this.accept)
        this.sending = true
        axios({
          method: 'post',
          url: 'http://localhost:8080/sw-gamification/www/wp-json/contact-form-7/v1/contact-forms/14/feedback',
          data: bodyFormData,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
          .then(function (response) {
            if (response.data.status == 'mail_sent') {
              _self.sent = true
              _self.$emit('sent', true)
              _self.sending = false
              return true
            } else if (response.data.status == 'acceptance_missing') {
              _self.errors.push('accept')
              _self.acceptError = 'Før du kan sende inn meldingen må du godta personvern.'
              _self.sending = false
              console.log('missing')
            } else {
              invalidField = response.data.invalid_fields[0]

              _self.errors.push('contact')
              _self.contactError = 'Du må skrive inn telefonnummer eller e-postadresse.'
              _self.sending = false
            }
          })
          .catch(function (response) {
            _self.sending = false
            console.log(response)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  position: relative;

  .btn--border-0 {
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ContactForm.vue